const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/teams/team/$teamId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/settings/teams/team/$teamId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});